import { FaqsImport } from '@/components/Faqs/import';

const DataBaseImportPage = () => {
  return <FaqsImport mode="page" />;
};

export default DataBaseImportPage;
